import '@/js/accordion';
import '@/js/buynow';
import '@/js/tabs';
import '@/js/routine';
import '@/js/video';
import '@/js/navigation';

$(function() {
	const $tabs = $('[data-role=tabs]');
	const $routine = $('[data-role=sensibio-routine]');
	const $video = $('[data-role=video]');
	const $buyNow = $('[data-role=buy-now]');
	const $navigation = $('#navigation');

	$video.video();
	$tabs.tabs();

	// Аккордеон: включаем ровно когда активен SCSS `noDesktop` (<=1024px).
	const shouldInitAccordion =
		typeof window.matchMedia === 'function'
			? window.matchMedia('(max-width: 1024px)').matches
			: window.innerWidth <= 1024;

	if (shouldInitAccordion) {
		const $accordion = $('[data-role=accordion]');
		$accordion.accordion();
	}

	$routine.routine();
	$buyNow.buynow();
	$navigation.navigation();
});
